import { VALIDATE_URL }
	from 'scoreboard/admin/model/import-connection-constants'

import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import AdminConnections from './admin-connections'
import Connection from './connection'
import DbConnectionWizard from './db-connection-wizard'
import FtpConnectionWizard from './ftp-connection-wizard'
import GoogleConnectionWizard from './google-connection-wizard'
import ZapierConnectionWizard from './zapier-connection-wizard'
import RestConnectionWizard from 'scoreboard/admin/connections/rest/rest-connection-wizard'
import permissions from 'scoreboard/components/permissions'
import AdminPanels from 'scoreboard/admin/admin-panels'
import { BroadcastChannel } from 'broadcast-channel'
import googleApi from 'scoreboard/components/google-api'
import spotlight from 'scoreboard/components/spotlight'
import AddDbConnectionMenu from 'scoreboard/admin/connections/add-db-connection-menu'
import Tooltip from 'scoreboard/components/tooltip'
import AddWsConnectionMenu from './add-ws-connection-menu'
import constants from 'scoreboard/components/constants'
const { DATABASE, FTP, GOOGLE_SHEETS, ZAPIER, WEB_SERVICE } = constants

var AdminImportConnections = AdminConnections.extend({

	heading: 'admin.importConnections',

	Model: Connection,

	/**
	 * Admin | Import Connections screen
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Number} [options.selectedId] The connection to spotlight
	 *
	 * @param {Array} options.connections a plain JavaScript array holding the
	 * connections
	 */
	initialize(options = {}) {
		AdminConnections.prototype.initialize.apply(this, arguments)
		// these 2 events are triggered in connection-label-and-owners.js:submit
		Backbone.on('add:import-connection', this._onAdd.bind(this))
		Backbone.on('edit:import-connection', item => {
			this._onEdit(item)
			this.forImportConnection()
		})
	},

	render() {
		AdminConnections.prototype.render.apply(this, arguments)
		this.renderPanel(DATABASE)
		this.renderPanel(FTP)
		// This requires that an Orb endpoint be configured with a google provider
		// If either are missing don't show the option
		if (googleApi.isAvailable()) {
			let panel = this.renderPanel(GOOGLE_SHEETS)
			// https://github.com/SpiderStrategies/Scoreboard/pull/30648#discussion_r445852097
			this.$(`.panel[data-type="${GOOGLE_SHEETS}"] li.disabled`).addClass('is-not-displayed')
			// #51140 show the empty state message if hiding connections with
			// status: 'disabled' would result in no visible connections in this
			// panel
			let visibleConnections = _.filter(this.collection, item => {
				return item.type === GOOGLE_SHEETS && item.status !== 'disabled'
			})
			if (_.isEmpty(visibleConnections)) {
				this.displayEmptyStateMessage(panel, GOOGLE_SHEETS)
			}
		}
		this.renderPanel(ZAPIER)
		this.renderPanel(WEB_SERVICE)
		this.forImportConnection()
		this.secure()

		this.spotlight(this.options.selectedId)

		return this
	},

	renderPanel() {
		// #22211 secure server import connections based on permissions
		let panel
		if (permissions.appAdmin() && permissions.modifyImportConnections()) {
			// draggable-list to allow reordering
			panel = AdminConnections.prototype.renderPanel.apply(this, arguments)
		} else {
			// non-draggable list of panels
			panel = AdminPanels.prototype.renderPanel.apply(this, arguments)
		}
		panel.attr('data-server-connection', 'true')
		return panel
	},

	/**
	 * Updates the view accordingly based on the fact this is an import connection
	 */
	forImportConnection: function () {
		// Import connections can't be disabled
		this.$('.toggle-connection').remove()
	},

	secure() {
		// #22211 secure server import connections based on permissions
		let serverConnectionPanel = this.$('[data-server-connection=true]')
		// prevent adding a new server import connection
		if (!permissions.modifyImportConnections()) {
			serverConnectionPanel.find('.add').hide()
		}
	},

	spotlight(id) {
		if (!id) {
			return
		}
		const el = this.$(`li[data-id='${id}']`)
		el.addClass('is-selected')[0].scrollIntoView()
		spotlight(el)
	},

	add(e) {
		let type = this.$(e.target).closest('[data-type]').data('type')
		if (type === DATABASE) {
			this.addDatabase(e)
		} else if (type === FTP) {
			addFtp()
		} else if (type === GOOGLE_SHEETS) {
			this.authBroadcastChannel = addGoogleSheets()
		} else if (type === ZAPIER) {
			addZapier()
		} else if (type === WEB_SERVICE) {
			this.addWebService(e)
		}
	},

	addDatabase(e) {
		let target = $(e.currentTarget)
		// #44888 show a tooltip menu when you click the Add Connection button
		// that allows the user to select the db product type before launching
		// the db connection wizard
		let addDbConnectionMenu = new AddDbConnectionMenu({
			validationUrl: VALIDATE_URL
		})
		this.addDbConnectionTooltip = new Tooltip({
			attachTo: target,
			content: addDbConnectionMenu,
			placement: 'below',
			arrow: 'right',
			extraClass: 'has-bootslide-menu'
		}).render()
	},

	addWebService(e) {
		this.addWsConnectionTooltip = new Tooltip({
			attachTo: $(e.currentTarget),
			content: new AddWsConnectionMenu(),
			placement: 'below',
			arrow: 'right',
			extraClass: 'has-bootslide-menu'
		}).render()
	},

	edit(e) {
		const item = this._item(e)
		var model = new Connection(item)
		const { type } = item
		if (type === FTP) {
			new FtpConnectionWizard({ model }).resume()
		} else if (type === GOOGLE_SHEETS) {
			new GoogleConnectionWizard({ model }).resume()
		} else if (type === ZAPIER) {
			new ZapierConnectionWizard({model}).resume()
		} else if (type === WEB_SERVICE) {
			new RestConnectionWizard({ model }).resume()
		} else {
			new DbConnectionWizard({
				model,
				validationUrl: VALIDATE_URL
			}).resume()
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.addDbConnectionTooltip], 'remove')
		_.invoke(this.authBroadcastChannel, 'close')
	}

})

function addFtp() {
	let model = new Connection({
		type: FTP,
		protocol: 'sftp',
		authentication: 'username-password'
	})
	new FtpConnectionWizard({ model }).start()
}

function addGoogleSheets() {
	const authBroadcastChannel = new BroadcastChannel('oauth-connections')
	authBroadcastChannel.onmessage = messageEvent => {
		const {connectionId, email} = messageEvent
		const model = new Connection({
			label: email,
			type: GOOGLE_SHEETS,
			orbReferenceId: connectionId,
			username: email
		})
		authBroadcastChannel.close()
		new GoogleConnectionWizard({model}).start()
	}
	window.open(googleApi.buildGoogleOAuthUrl(), 'oauth', 'width=475,height=550')
	return authBroadcastChannel
}

function addZapier() {
	let model = new Connection({
		type: ZAPIER
	})
	const wizard = new ZapierConnectionWizard({
		model,
		xhr: $.post('api/admin/import-connections/zapier')
	}).start()
	wizard.on('cancel', () => {
		// We didn't create the import connection, so get rid of the token
		// that we just created in Orb
		const orbReferenceId = model.get('orbReferenceId')
		$.delete(`api/admin/import-connections/zapier/${orbReferenceId}`)
	})
}

export default AdminImportConnections
export {
	GOOGLE_SHEETS, FTP, ZAPIER,
	addGoogleSheets, addFtp, addZapier
}
AdminImportConnections.__filename__ = 'admin/connections/admin-import-connections.js'
